import {Lang} from 'yougile-lang'
import {Time} from 'yougile-util'

export const isThatDay = (
  timestamp: number,
  type: 'current' | 'yesterday' | 'tomorrow' = 'current'
): boolean => {
  const today = new Date()
  const date = new Date(timestamp)

  switch (type) {
    case 'current':
      return (
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
      )
    case 'yesterday':
      const yesterday = new Date(today)
      yesterday.setHours(today.getHours() - 24)
      return (
        date.getDate() === yesterday.getDate() &&
        date.getMonth() === yesterday.getMonth() &&
        date.getFullYear() === yesterday.getFullYear()
      )
    case 'tomorrow':
      const nextDay = new Date(today)
      nextDay.setHours(today.getHours() + 24)
      return (
        date.getDate() === nextDay.getDate() &&
        date.getMonth() === nextDay.getMonth() &&
        date.getFullYear() === nextDay.getFullYear()
      )
    default:
      throw new Error('Invalid type')
  }
}

export const isThatDayByDate = (
  timestamp: number,
  timestampToCompare: number
): boolean => {
  if (Math.abs(timestamp - timestampToCompare) > Time.day) {
    return false
  }

  const date = new Date(timestamp)
  const dateToCompare = new Date(timestampToCompare)

  const result =
    date.getDate() === dateToCompare.getDate() &&
    date.getMonth() === dateToCompare.getMonth() &&
    date.getFullYear() === dateToCompare.getFullYear()

  return result
}

export const customFormatDate = (date: number, withWith = true): string => {
  let result = ''
  if (isThatDay(date, 'current')) {
    result += Lang.msg.crm.activitiesView.today
  } else if (isThatDay(date, 'yesterday')) {
    result += Lang.msg.crm.activitiesView.yesterday
  } else if (isThatDay(date, 'tomorrow')) {
    result += Lang.msg.crm.activitiesView.tomorrow
  }

  const skipDate = result.length > 0

  if (result && withWith) {
    result += ' в '
  }

  return (
    result + Time.formatDateTime(date, false, false, true, true, true, skipDate)
  )
}

export const getDayFull = (date: number): string => {
  if (isThatDay(date, 'current')) {
    return Lang.msg.crm.activitiesView.today
  } else if (isThatDay(date, 'yesterday')) {
    return Lang.msg.crm.activitiesView.yesterday
  } else if (isThatDay(date, 'tomorrow')) {
    return Lang.msg.crm.activitiesView.tomorrow
  }

  return Time.formatDate(date, {
    alwaysWithYear: false,
    fullMonth: true
  })
}
